import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/AlternateEmail';
import type { LoadingButtonProps } from '@mui/lab';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';

import { apiPaths } from 'src/services/api/apiPaths';
import HttpServiceInstance from 'src/services/api/http';

export interface InformUserButtonProps extends LoadingButtonProps {
  userId: number;
}

const InformUserButton: FC<InformUserButtonProps> = ({ userId, loading }) => {
  const { t } = useTranslation('admin');
  const { enqueueSnackbar } = useSnackbar();

  return (
    <LoadingButton
      variant="cta"
      color="tertiary"
      disabled={!userId}
      loading={loading}
      onClick={() =>
        HttpServiceInstance.post(
          `${apiPaths.ADMIN.USER}${userId}/notify/`,
          {},
        ).then(() => {
          enqueueSnackbar(t('Detail.EmailSent'), {
            variant: 'success',
          });
        })
      }
      startIcon={<EmailIcon />}
    >
      {t('admin:Detail.InformUser')}
    </LoadingButton>
  );
};

export default InformUserButton;
